import React, {lazy, Suspense} from 'react';
import LoadingIndicator from './loading_indicator.jsx';

const LexicalEditor = lazy(() => import('./richTextPlugins/LexicalEditor.jsx'));

export default function RichText(props) {
  return <Suspense fallback={<LoadingIndicator />}>
    <LexicalEditor {...props} />
  </Suspense>
}
